import React from "react";
import { FormContainer } from "./style";
import Profile from "components/profile";
import Button from "components/button";
const FormView = ({ nextStep, prev }) => {
  return (
    <FormContainer>
      <div className="title">
        <h5>تکمیل اطلاعات</h5>
      </div>
      <Profile nextStep={nextStep} />
      <div className="prev">
        <Button title="مرحله قبل" onClick={prev} />
      </div>
    </FormContainer>
  );
};
export default FormView;
